import { Component } from '@angular/core';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';
import { LoginModel, Stores } from 'src/app/Models/ApplicationModels';
import { MasterDataSeriveService } from 'src/app/Services/master-data-serive.service';
import { AdminBreadcrumbsService } from 'src/app/rcs/admin-module/admin-services/admin-breadcrumbs.service';
import { OverrideStatus } from 'src/app/enum/enum';
import { ProductionCycle } from 'src/app/rcs/admin-module/company-config/WeekColors/models/week-color.model';
import { WeekColorService } from 'src/app/rcs/admin-module/company-config/WeekColors/services/week-color.service';
import { ReportsV3ApiService } from '../../services/reports-v3-api.service';
import { DepartmentDetailsV3 } from '../models/production-overview-admin-v3-models';

@Component({
  selector: 'app-production-overview-admin-table-v3',
  templateUrl: './production-overview-admin-table-v3.component.html',
  styleUrls: ['./production-overview-admin-table-v3.component.css'],
})
export class ProductionOverviewAdminTableV3Component {
  userInfo: LoginModel = new LoginModel();
  stores: Array<Stores> = [];
  storeId: number = 0;
  storeName: string = 'All stores';
  startDate: any;
  endDate: any;
  isLoading: boolean = false;
  reportHasRun: boolean = false;
  showWeekColor: boolean = true;
  weekColor: string = 'All Week Colors';
  weekColorsList: Array<ProductionCycle> = [];
  productionCycleId: number = 0;
  isActive: boolean = true;
  activeStatusLabel: string = 'Active';
  departments: DepartmentDetailsV3[] = [];
  isBackendUnsupported: boolean = false;
  public daterange: any = {};

  public options: any = {
    locale: { format: 'MM/DD/YYYY', separator: ' - ', applyLabel: 'Apply', cancelLabel: 'Cancel' },
    alwaysShowCalendars: true,
    showDropdowns: false,
    showCustomRangeLabel: true,
    maxDate: new Date(),
    ranges: {
      Today: [moment(), moment()],
      Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
      'Last 7 Days': [moment().subtract(6, 'days'), moment()],
      'This Month': [moment().startOf('month'), moment().endOf('month')],
    },
    opens: 'left',
  };

  constructor(
    private datepipe: DatePipe,
    private masterservice: MasterDataSeriveService,
    private adminBreadcrumbs: AdminBreadcrumbsService,
    private weekColorService: WeekColorService,
    private reportsV3Service: ReportsV3ApiService
  ) { }

  ngOnInit() {
    this.adminBreadcrumbs.updateBreadcrumbs([
      { crumbName: 'Reports', link: 'demo' },
      { crumbName: 'Production Overview Admin Table', link: '/admin/home/v3/production-overview-admin-table' },
    ]);
    this.startDate = moment();
    this.endDate = moment();
    this.userInfo = JSON.parse(localStorage.getItem('user')!);
    const productionScheduleType = (this.userInfo as any)?.productionScheduleType?.toString()?.trim()?.toLowerCase();
    this.showWeekColor = productionScheduleType !== 'datespecific';
    this.getStores();
    if (this.showWeekColor) {
      this.getWeekColors();
    }
  }

  getStores() {
    let user = this.masterservice.getUserDetailsFromStorage();
    this.masterservice.getallstores(user.companyID).subscribe((res) => {
      if (Array.isArray(res)) {
        this.stores = res;
      }
    });
  }

  getWeekColors() {
    let user = this.masterservice.getUserDetailsFromStorage();
    this.weekColorService.getProductionCycles(user.companyID).subscribe((res) => {
      this.weekColorsList = (res as ProductionCycle[]).filter(
        (item) => item.status === OverrideStatus.Active
      );
    });
  }

  selectAllStores() {
    this.storeName = 'All stores';
    this.storeId = 0;
  }

  setStore(store: Stores) {
    this.storeName = store.storeName;
    this.storeId = store.storeId;
  }

  selectAllColors() {
    this.weekColor = 'All Week Colors';
    this.productionCycleId = 0;
  }

  setWeekColor(wk: ProductionCycle) {
    this.weekColor = wk.displayName;
    this.productionCycleId = wk.id;
  }

  setActiveStatus(status: boolean, label: string) {
    this.isActive = status;
    this.activeStatusLabel = label;
  }

  public selectedDate(value: any, datepicker?: any) {
    this.endDate = value.end._d;
    this.startDate = value.start._d;
    if (datepicker) {
      datepicker.start = value.start;
      datepicker.end = value.end;
    }
    this.daterange.start = value.start;
    this.daterange.end = value.end;
    this.daterange.label = value.label;
  }

  runReport() {
    this.reportHasRun = true;
    this.loadTableData();
  }

  loadTableData() {
    this.isLoading = true;
    const formattedStartDate = this.datepipe.transform(this.startDate, 'yyyy-MM-dd HH:mm:ss');
    const formattedEndDate = this.datepipe.transform(this.endDate, 'yyyy-MM-dd HH:mm:ss');
    this.reportsV3Service
      .getProductionOverviewAdminTableV3(
        this.userInfo.companyID,
        this.storeId,
        this.isActive,
        formattedStartDate,
        formattedEndDate,
        this.productionCycleId
      )
      .subscribe({
        next: (res: any) => {
          const items = res?.dashboardDetail ?? (Array.isArray(res) ? res : []);
          // Backend gap: v3 currently returns a Department x Category x Producer x Store qty
          // breakdown (departmentDescr/deptQty/categoryName/catQty/userName/storeName), not the
          // flat department summary (departmentName/producedAmount/soldQty/revenue/
          // sellThroughPercentage/isActive) this table is built for. Flag it instead of rendering
          // duplicated/mismatched rows.
          this.isBackendUnsupported = items.length > 0 && items[0]?.producedQty === undefined;
          this.departments = this.isBackendUnsupported ? [] : items;
        },
        error: () => { this.isLoading = false; },
        complete: () => { this.isLoading = false; },
      });
  }
}
